// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/global.css'
import '@/assets/css/animate.css'
import './plugins/codemirror.js'
import axios from 'axios'
import * as echarts from 'echarts'
import VueUeditorWrap from 'vue-ueditor-wrap'
import cookie from './util/cookie'

Vue.component('vue-ueditor-wrap', VueUeditorWrap);

Vue.config.productionTip = false;
// 全局设置 elementUI的$message的默认显示时间
const messages = ['success', 'warning', 'info', 'error'];
messages.forEach(type => {
  Element.Message[type] = options => {
    if (typeof options === 'string') {
      options = {
          message: options
      };
      // 默认配置
      options.duration = 1000;
      options.showClose = true;
    }
    options.type = type;
    return Element.Message(options);
  }
})
Vue.use(Element);

Vue.prototype.$echarts = echarts;
Vue.prototype.$baseUrl = process.env.baseUrl;
Vue.prototype.cookie = cookie;

router.afterEach((to, from) => {
  window.scrollTo(0,0);
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  axios,
  echarts,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js